export default "__VITE_ASSET__7f08a82e__"